import { Pipe, PipeTransform } from '@angular/core';

import { stationName } from '../constants/constants';

@Pipe({ name: 'statioName', pure: true, standalone: true })
export class StationNamePipe implements PipeTransform {
  transform(value: any, stations: any[]): any {
    return stationName(value, stations);
  }
}
